import { PlayerSearchTimeType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const playerSearchTimeName: { [key in PlayerSearchTimeType]: TKeyType } = {
  [PlayerSearchTimeType.CREATED_AT]: 'common.registeredAt',
  [PlayerSearchTimeType.LAST_LOGIN_AT]: 'common.loginTime'
}

export default playerSearchTimeName
